import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  endpoint = environment.nodeEndpoint;
  constructor(
    private authService: AuthService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    //  auth alert popup api endpoints 
    let authAlertEndpoints = [
      'chat-completion', 'playground', 'uploader', 'translate_upload', 'translate_start', 'translate_status',
      'translate_download_file', 'translate_delete_files', 'getanswer', 'upload_video', 'status', 'transcript',
      'upload-userfile', 'chat-bot', 'chat-bot-stream-new', 'chat-uploads',
      'azure-dalle3', 'chat-bot-stream', 'create-assistant',
      'search-bing-images', 'chat-bot-clear', 'chat-uploads-status', 'chat-uploads',
      'create-assistant', 'run-status', 'first-query', 'add-query', 'da-plugin','graphapi','chat','upload','gen-prompt'
    ];


    // Get the API URL endpoint
    let apiEndpoint = req.url.split('/');
    var finalUrl = apiEndpoint[apiEndpoint?.length - 1].split('?')[0];
    // console.log("finalUrl==>", finalUrl);

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = '';

        if (error.error instanceof ErrorEvent) {
          // Client-side errors
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // Server-side errors
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }

        // You can add more specific error handling based on status codes here
        switch (error.status) {
          case 400:
            // Handle Bad Request
            errorMessage = 'Bad Request';
            break;
          case 401: {
            if (authAlertEndpoints.includes(finalUrl)) {
              return this.authService.getTokenByRefreshToken().pipe(
                switchMap((res: any) => {
                  if (res?.status === 'success') {
                    const userInfo = res?.data;
                    var token = userInfo?.id_token;
                    localStorage.setItem('token', token);
                    const refresh_token = userInfo?.refresh_token;
                    localStorage.setItem('refresh_token', refresh_token);

                    // Clone the original request and set the new token in the header
                    const clonedReq = req.clone({
                      headers: new HttpHeaders({
                        'Authorization': `Bearer ${token}`,
                        'Auth-platform': 'mobile',
                        'old-ui': 'prod'
                      })
                    });

                    // Retry the request with the new token
                    return next.handle(clonedReq);
                  } else {
                    console.log('error', res?.message);
                    return throwError(res?.message);
                  }
                }),
                catchError((refreshError) => {

                  return throwError(refreshError);
                })
              );

              // this.updateSession();
            }
            // Handle Unauthorized
            errorMessage = 'Unauthorized';
            break;
          }
          case 403:
            // Handle Forbidden
            errorMessage = 'Forbidden';
            break;
          case 404:
            // Handle Not Found
            errorMessage = 'Not Found';
            break;
          case 500:
            // Handle Internal Server Error
            errorMessage = 'Internal Server Error';
            break;
          default:
            errorMessage = `Unexpected Error: ${error.status}`;
        }

        // Optionally, you can show the error message to the user using a service or a component
        // console.log(errorMessage);
        if (errorMessage != 'Unauthorized' && finalUrl != 'refresh') {
          // this.toastMessage.showError(errorMessage);
        }

        return throwError(error);
      })
    );
  }


  updateSession() {
    document.getElementById('alert_model1')?.click();
  }
}
